import { all, fork } from 'redux-saga/effects';
import GetFiltersSaga from './sagas/handleGetAllFilters';
import GetDashboardRowsSaga from './sagas/handleGetAllDashboardRows';
// I'm not sure why we import the default for handleGetAllTotals twice and use it twice. Leaving it as it is for safety
import GetTotalsSaga from './sagas/handleGetAllTotals'; // eslint-disable-line import/no-duplicates
import GetDashboardTotalsSaga from './sagas/handleGetAllTotals'; // eslint-disable-line import/no-duplicates

function* OffersDashboardSaga() {
  yield all([fork(GetDashboardRowsSaga)]);
  yield all([fork(GetFiltersSaga)]);
  yield all([fork(GetDashboardTotalsSaga)]);
  yield all([fork(GetTotalsSaga)]);
}

export default OffersDashboardSaga;
